import React, { useEffect, useState } from "react"
import { RESULT_PROPS } from "./interface"
import { ResultText } from "./ResultStyled"
import { Currencies } from "@orbital/games-frontend-library"
// import useSound from "use-sound";
// import loseSFX from "../../assets/audioL/loseSFX.mp3";

export default function Result({
  currency,
  stateRound,
  showGamble,
  isHolded,
  lastCardRotated,
  precision,
}: // audio,
RESULT_PROPS) {
  const { winamount, state } = stateRound
  // const { sound, volume } = audio;

  const [resultText, setResultText] = useState<boolean>(false)
  // const [playLoseSFX] = useSound(loseSFX, {
  //   volume: parseFloat(volume),
  // });

  useEffect(() => {
    let timeout: any
    if ((state === 5 || state === 7) && lastCardRotated && !showGamble) {
      setResultText(true)
      setTimeout(() => {
        setResultText(false)
      }, 835)
    } else {
      setResultText(false)
      clearTimeout(timeout)
    }
    return function cleanup() {
      clearTimeout(timeout)
    }
  }, [state, lastCardRotated, showGamble])

  // useEffect(() => {
  //   showResult && winamount <= 0 && sound && playLoseSFX();
  // }, [showResult, playLoseSFX, winamount, sound]);

  return (
    <ResultText
      fadeIn={resultText}
      isWin={winamount > 0}
      isTop={isHolded.includes(1)}
    >
      WIN {winamount.toFixed(precision)} {Currencies[currency]}
    </ResultText>
  )
}
